export const SITE = {
  name: "Vision Building Systems, L.L.C.",
  shortName: "VBS",
  tagline: "Providing Temporary and Permanent Buildings with Modular Construction",
  phone: "407-256-6141",
  phoneHref: "tel:+14072566141",
  emails: [
    { label: "Stephen P. Koertge, President", address: "spk1152@gmail.com" },
    { label: "John W. Pohlman, Executive Vice President", address: "jwpohlman01@gmail.com" },
  ],
  serviceArea: "Serving the entire Southeastern United States",
};

export const NAV_LINKS = [
  { to: "/products", label: "Products", testId: "nav-link-products" },
  { to: "/services", label: "Services", testId: "nav-link-services" },
  { to: "/gallery", label: "Photo Gallery", testId: "nav-link-gallery" },
  { to: "/financing", label: "Financing", testId: "nav-link-financing" },
  { to: "/about", label: "About Us", testId: "nav-link-about" },
  { to: "/contact", label: "Contact", testId: "nav-link-contact" },
];

export const ADVANTAGES = [
  {
    icon: "PencilRuler",
    title: "Customized Design",
    text: "Our experienced team will analyze your space requirements, providing you with innovative solutions that meet your design and budget expectations.",
  },
  {
    icon: "Blocks",
    title: "Modular Flexibility",
    text: "The versatility of VBS modular buildings provides a practical solution to your ever changing business climate. Our buildings can easily be expanded or relocated as the need arises.",
  },
  {
    icon: "ShieldCheck",
    title: "High Quality",
    text: "Our modular buildings employ the strongest construction technologies in either wood, steel or concrete — engineered to meet or surpass all applicable building code requirements.",
  },
  {
    icon: "Timer",
    title: "Quick Completion",
    text: "VBS buildings are manufactured off-site while on-site preparation and foundations are completed. This concurrent method allows VBS to complete your project in as little as half the time of conventional construction.",
  },
  {
    icon: "PiggyBank",
    title: "Cost Savings",
    text: "Modular construction is very cost competitive with conventional construction and in most cases costs less — with additional savings from reduced construction interest costs.",
  },
  {
    icon: "Handshake",
    title: "Flexible Financing",
    text: "Custom designed operating or financing lease packages may allow you to begin your project earlier than expected, while preserving current funds for business operations.",
  },
];

export const PRODUCTS = [
  "Sales Centers",
  "Office Buildings",
  "Educational Facilities",
  "Health Care / Medical",
  "Commercial Applications",
];

export const SERVICES = [
  "Building Design",
  "Architectural / Engineering",
  "Project Management",
  "Delivery / Installation",
  "Decks / Handicap Ramps / Skirting",
];

export const PROCESS_STEPS = [
  {
    step: 1,
    title: "Site Excavation & Preparation",
    img: "/images/gs-2.jpg",
  },
  {
    step: 2,
    title: "Foundation & Concrete Stem Wall Set",
    img: "/images/gs-3.jpg",
  },
  {
    step: 3,
    title: "Modular Crane Delivery & Precision Placement",
    img: "/images/gs-4.jpg",
  },
  {
    step: 4,
    title: "Structural Connection & Exterior Finishing",
    img: "/images/gs-7.jpg",
  },
  {
    step: 5,
    title: "Final Turn-Key Ground-Level Delivery",
    img: "/images/gs-8.jpg",
  },
];

export const EXTERIORS = [
  { img: "/images/ext-sales-hardilap.jpg", caption: "Sales Center – Hardi lap with full shingle mansard" },
  { img: "/images/ext-sales-1.jpg", caption: "Sales Center" },
  { img: "/images/ext-sales-2.jpg", caption: "Sales Center" },
  { img: "/images/ext-sales-3.jpg", caption: "Sales Center" },
  { img: "/images/ext-auto-sales.jpg", caption: "Auto Sales Center" },
  { img: "/images/ext-exec-hardilap.jpg", caption: "Executive Office – Hardi lap siding with full shingle mansard" },
  { img: "/images/ext-exec-1.jpg", caption: "Executive Office" },
  { img: "/images/ext-exec-stucco.jpg", caption: "Executive Office – Ground set stucco exterior with full metal mansard" },
  { img: "/images/ext-office-ground.jpg", caption: "Office Building – Ground set to match existing building" },
  { img: "/images/ext-office-hardi.jpg", caption: "Office Building – Hardi panel exterior with false mansard" },
  { img: "/images/ext-office-aluminum.jpg", caption: "Office Building – High rib aluminum exterior" },
  { img: "/images/ext-office-metal.jpg", caption: "Office Building – Full metal roof" },
  { img: "/images/ext-clubhouse-crane.jpg", caption: "Club House – Crane set stucco exterior with site built roof" },
  { img: "/images/ext-clubhouse-ground.jpg", caption: "Club House – Ground set stucco exterior with site built roof" },
  { img: "/images/ext-proshop-metal.jpg", caption: "Pro Shop – Full metal mansard" },
  { img: "/images/ext-proshop-shingle.jpg", caption: "Pro Shop – Full shingle mansard" },
  { img: "/images/ext-proshop-stucco.jpg", caption: "Pro Shop – Stucco exterior with full barrel tile mansard" },
  { img: "/images/ext-proshop-hardilap.jpg", caption: "Pro Shop – Hardi lap with full shingle mansard" },
  { img: "/images/ext-shower-laundry.jpg", caption: "Shower / Laundry Facility – Full metal roof" },
  { img: "/images/ext-education.jpg", caption: "Educational Building – Ground set stucco exterior with site built roof" },
  { img: "/images/ext-library.jpg", caption: "Library – Ground set with full metal mansard" },
  { img: "/images/ext-church.jpg", caption: "Church – Hardi exterior with false mansard" },
  { img: "/images/ext-hardi-1.jpg", caption: "Hardi Panel Exterior with False Mansard" },
  { img: "/images/ext-hardi-2.jpg", caption: "Hardi Panel Exterior with False Mansard" },
  { img: "/images/ext-hardi-3.jpg", caption: "Hardi Panel Exterior with False Mansard" },
  { img: "/images/adv-1.jpg", caption: "Custom Modular Building" },
  { img: "/images/team-steve.jpg", caption: "Custom Modular Building" },
  { img: "/images/team-john.jpg", caption: "Custom Modular Building" },
  { img: "/images/client-1.jpg", caption: "Office Building – Full metal roof" },
  { img: "/images/work-cover.jpg", caption: "Sales Center – Hardi lap with full shingle mansard" },
  { img: "/images/locations.jpg", caption: "VBS Project – Southeastern United States" },
];

export const INTERIORS = [
  { img: "/images/int-1.jpg", caption: "Office Interior" },
  { img: "/images/int-2.jpg", caption: "Office Interior" },
  { img: "/images/int-3.jpg", caption: "Office Interior" },
  { img: "/images/int-4.jpg", caption: "Office Interior" },
  { img: "/images/int-5.jpg", caption: "Office Interior" },
  { img: "/images/int-6.jpg", caption: "Office Interior" },
  { img: "/images/int-corridor.jpg", caption: "Standard Office Corridor" },
  { img: "/images/int-cubicles.jpg", caption: "Office with Cubicles" },
  { img: "/images/int-7.jpg", caption: "Office Interior" },
  { img: "/images/int-breakroom.jpg", caption: "Breakroom" },
  { img: "/images/int-daycare.jpg", caption: "Daycare" },
  { img: "/images/int-8.jpg", caption: "Multi-Purpose Room" },
  { img: "/images/int-library.jpg", caption: "Library" },
  { img: "/images/int-assembly.jpg", caption: "Assembly" },
  { img: "/images/int-imaging.jpg", caption: "Imaging Room" },
  { img: "/images/int-office-1.jpg", caption: "Office" },
  { img: "/images/int-office-2.jpg", caption: "Office" },
  { img: "/images/int-office-3.jpg", caption: "Office" },
  { img: "/images/int-office-4.jpg", caption: "Office" },
];

export const FLOOR_PLANS = [
  { img: "/images/fp-office-1.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-office-2.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-office-3.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-office-4.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-office-5.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-office-6.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-office-7.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-office-8.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-office-9.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-office-10.jpg", caption: "Office", category: "Office" },
  { img: "/images/fp-sales-1.jpg", caption: "Sales Center", category: "Sales Center" },
  { img: "/images/fp-sales-2.jpg", caption: "Sales Center", category: "Sales Center" },
  { img: "/images/fp-sales-3.jpg", caption: "Sales Center", category: "Sales Center" },
  { img: "/images/fp-sales-4.jpg", caption: "Sales Center", category: "Sales Center" },
  { img: "/images/fp-medical-1.jpg", caption: "Health Care / Medical", category: "Health Care / Medical" },
  { img: "/images/fp-medical-2.jpg", caption: "Health Care / Medical", category: "Health Care / Medical" },
  { img: "/images/fp-medical-3.jpg", caption: "Health Care / Medical", category: "Health Care / Medical" },
  { img: "/images/fp-medical-4.jpg", caption: "Health Care / Medical", category: "Health Care / Medical" },
  { img: "/images/fp-medical-5.jpg", caption: "Health Care / Medical", category: "Health Care / Medical" },
  { img: "/images/fp-medical-6.jpg", caption: "Health Care / Medical", category: "Health Care / Medical" },
  { img: "/images/fp-medical-7.jpg", caption: "Health Care / Medical", category: "Health Care / Medical" },
  { img: "/images/fp-medical-8.jpg", caption: "Health Care / Medical", category: "Health Care / Medical" },
  { img: "/images/fp-class-1.jpg", caption: "Classroom – Daycare", category: "Classroom / Daycare" },
  { img: "/images/fp-class-2.jpg", caption: "Classroom – Daycare", category: "Classroom / Daycare" },
  { img: "/images/fp-class-3.jpg", caption: "Classroom – Daycare", category: "Classroom / Daycare" },
  { img: "/images/fp-class-4.jpg", caption: "Classroom – Daycare", category: "Classroom / Daycare" },
  { img: "/images/fp-religious-1.jpg", caption: "Religious", category: "Religious" },
  { img: "/images/fp-religious-2.jpg", caption: "Religious", category: "Religious" },
  { img: "/images/fp-religious-3.jpg", caption: "Religious", category: "Religious" },
  { img: "/images/fp-locker-1.jpg", caption: "Locker Room", category: "Locker Room" },
  { img: "/images/fp-locker-2.jpg", caption: "Locker Room", category: "Locker Room" },
  { img: "/images/fp-locker-3.jpg", caption: "Locker Room", category: "Locker Room" },
];

export const GROUND_SET = [
  { img: "/images/gs-1.jpg", caption: "Ground Set Delivery" },
  { img: "/images/gs-2.jpg", caption: "Site Preparation" },
  { img: "/images/gs-3.jpg", caption: "Foundation Set" },
  { img: "/images/gs-4.jpg", caption: "Module Placement" },
  { img: "/images/gs-5.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-6.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-7.jpg", caption: "Exterior Connection" },
  { img: "/images/gs-8.jpg", caption: "Exterior Finishing" },
  { img: "/images/gs-9.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-10.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-11.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-12.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-13.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-14.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-15.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-16.jpg", caption: "Office Building – Ground set to match existing building" },
  { img: "/images/gs-17.jpg", caption: "Ground Set Installation" },
  { img: "/images/gs-18.jpg", caption: "Completed Ground Set Building" },
  { img: "/images/setup-ground.jpg", caption: "Ground Level Setup" },
  { img: "/images/setup-hero.jpg", caption: "Ground Set Process" },
  { img: "/images/hero-2.jpg", caption: "Permanent Modular Building Process" },
];

export const TEAM = [
  {
    name: "Stephen P. Koertge",
    role: "President",
    img: "/images/team-steve.jpg",
    email: "spk1152@gmail.com",
    bio: "Prior to joining VBS as a founding member, Steve served eight years with GE Capital Modular Space in a variety of roles. Most recently Steve was Major Projects Account Manager and Healthcare Sales Specialist for the Southeast U.S. and Florida regions. In 1998 Steve was the #1 Healthcare Specialist and in 1997, the #2 Major Projects Manager in the Company. Prior to this, Steve was the Branch General Manager for one of the largest branches in the U.S. earning Excellence Circle Awards every year. Steve was also instrumental in several \u201cProcess and Quality Improvement Teams\u201d earning additional Excellence Circle Awards. Steve holds a B.S. degree in Industrial Management with minor degrees in Marketing and Accounting from Purdue University. Steve completed additional programs including Sales Greenbelt Quality Training, Customer Focused Selling, Management Skills for Leaders, and Facilitators Workshop.",
  },
  {
    name: "John W. Pohlman",
    role: "Executive Vice President",
    img: "/images/team-john.jpg",
    email: "jwpohlman01@gmail.com",
    bio: "Prior to joining VBS as a founding member, John served seven years with GE Capital Modular Space, most recently as Senior Accounts / Major Projects Representative earning Top 5 status in each of the last five years including #1 in the U.S. in 1998 and #2 in the U.S. in 1997. At GE, John was consistently a top performer due to his personal dedication, attention to detail, and outstanding customer service after the sale. Prior to GE Capital Modular Space, John worked with Atlantic Envelope, a Fortune 500 company where he earned Top Sales Representative awards on several occasions. John holds a B.S. degree in Communications with a minor degree in Marketing from Bowling Green State University. John has also completed additional programs including Sales Greenbelt Quality Training, Customer Focused Selling, The Science of Selling, and The Tom Hopkins Sales Seminar.",
  },
];

export const TESTIMONIAL = {
  quote:
    "\u2026our staff is very happy with the facility. It is very well built, comfortable, and efficient. The factory that built it\u2026 did a very good job. The fit and finish of all the components is better than we expected. They were also a pleasure to deal with and extremely responsive in completing all the little finishing details once the building was on site.",
  author: "David Grissiaffi",
  role: "Happy Client",
};
